/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ detail: NonNullable<unknown> }} Cc_Embed_Error_IoInputs */



/**
* | output |
* | --- |
* | "The file could not be read: {detail}" |
*
* @param {Cc_Embed_Error_IoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cc_embed_error_io = /** @type {((inputs: Cc_Embed_Error_IoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_Embed_Error_IoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible de lire le fichier : ${i?.detail}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Datei konnte nicht gelesen werden: ${i?.detail}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile leggere il file: ${i?.detail}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Файл не удалось прочитать: ${i?.detail}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo leer el archivo: ${i?.detail}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文件无法读取：${i?.detail}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ファイルが読み取れませんでした: ${i?.detail}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ़ाइल पढ़ी नहीं जा सकी: ${i?.detail}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível ler o arquivo: ${i?.detail}`)
	return /** @type {LocalizedString} */ (`The file could not be read: ${i?.detail}`)
});